import { render } from "./sidebar-navigation.vue?vue&type=template&id=3d0187e0&scoped=true"
import script from "./sidebar-navigation.vue?vue&type=script&lang=js"
export * from "./sidebar-navigation.vue?vue&type=script&lang=js"

import "./sidebar-navigation.vue?vue&type=style&index=0&id=3d0187e0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0187e0"]])

export default __exports__